<ng-template [ngIf]="isAmostraPendente()">
    <span class="badge badge-config-pedido-tipo-venda badge-config-pedido-tipo-venda-amostra-pendente"
        [title]="isAbreviacao ? tipo.nomeAmostraPendente : ''">
        {{isAbreviacao ? tipo.abreviacaoAmostraPendente : tipo.nomeAmostraPendente}}
    </span>
</ng-template>

<ng-template [ngIf]="!isAmostraPendente()">
    <span class="badge badge-config-pedido-tipo-venda badge-config-pedido-tipo-venda-amostra"
        [title]="isAbreviacao ? tipo.nome : ''">
        {{isAbreviacao ? tipo.abreviacao : tipo.nome}}
    </span>
</ng-template>
